// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dev-hub-page-body_wrapper__mHdXU"};